var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilledLogout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 28C14.3125 28 13 26.6562 13 25V17C13 15.3438 14.3125 14 16 14H18C18.5312 14 19 14.4688 19 15C19 15.5625 18.5312 16 18 16H16C15.4375 16 15 16.4688 15 17V25C15 25.5625 15.4375 26 16 26H18C18.5312 26 19 26.4688 19 27C19 27.5625 18.5312 28 18 28H16ZM28.75 20.4688C29.0625 20.75 29.0625 21.2812 28.75 21.5312L24.25 25.7812C24.0312 26 23.7188 26.0312 23.4375 25.9375C23.1562 25.8125 23 25.5312 23 25.25V23H19C18.4375 23 18 22.5625 18 22V20C18 19.4688 18.4375 19 19 19H23V16.75C23 16.4688 23.1562 16.1875 23.4375 16.0625C23.7188 15.9688 24.0312 16 24.25 16.2188L28.75 20.4688Z",
    fill: "#5F6774"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilledLogout);
export default __webpack_public_path__ + "static/media/filledLogout.d932a4a21a1b571b5d8f8273ac7d5008.svg";
export { ForwardRef as ReactComponent };